import React, { Component } from "react";

import WaterBathOpen from "../../img/waterbath-open.svg";
import WaterBathClosed from "../../img/waterbath-closed.svg";
import WaterBathFullOpen from '../../img/waterbath-with-rack-open.svg'

import {Graphics as FloatingTubeRack} from "../../../floatingTubeRack/components/Graphics";
// import FloatingTubeRack from "../floatingTubeRack/Graphics";

import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import Toast from '../../../toast/Toast'
import colors from  '@learningblocks/protocol-constants/lib/Styles/_colors.scss';
import { TooltipControls } from '../TooltipControls';

const images = {
  WaterBathOpen: WaterBathOpen,
  WaterBathClosed: WaterBathClosed,
  WaterBathFullOpen: WaterBathFullOpen
};

export class Graphics extends Component {

  constructor(props){
    super(props);
    this.state = {
      lastX:0,
      lastY:0
    }
  };


  toggleToolTipControlsForWaterBath = () => {
    this.props.toggleToolTipControlsForWaterBath({
      id: this.props.id,
      showToolTipControls: true
    })
  }

  toggleOpen = () => {
    this.toggleToolTipControlsForWaterBath()
    console.log('toggle: ', this.props);
    const payload = {
      id: 1,
      open: !this.props.open,
    }
    console.log('payload @ toggle: ', payload);
    this.props.waterBathOpen(payload);
  };

  showModal = () =>{
    this.props.setModal({
      display: false,
      type: "WATER_BATH_CONTROLS",
      size: 'lg',
      waterBathId: this.props.id,
      connect: -1
    })
    this.props.showModal({display: true})
  }

  makeToast = (type, msg, title) => {
      let color = ""
      if(type==="HINT"){
        color = colors.yellow1
      } else {
        color = colors.red1
      }

      toast(<Toast type={type} msg={msg} title={title} />, {
        className: css({
          border: "2px solid "+color,
          borderRadius: "6px",
          marginLeft: "-200px",
          minWidth: "400px",
          paddingLeft: 0
        }),
        progressClassName: css({
          background: color
        }),
        position: "top-center",
        autoClose: 5000,
      });
  };

  ejectRack = () =>{
    if(this.props.open){
      if(this.props.hasRack){
        this.props.tubeInWaterBath({
          inWaterBath: false,
          id: this.props.id,
        });
        this.props.waterBathContainsTubeRack({
          containsTubeRack: false,
          id: this.props.id,
        });
      } else {
        this.makeToast('WARNING', 'There is nothing to eject.', 'Empty!')
      }
    } else {
      this.makeToast('WARNING', 'Please open the waterbath door.', 'Waterbath Closed!')
    }
  }

  renderEjectBtn = () => {
    return (
      <div class="eject-button" tabIndex={0} onClick={this.ejectRack} onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.ejectRack(e)} }> Eject </div>
    )
  }

  // function for triggering mouse events
  fireMouseEvent = (type, elem, centerX, centerY) => {
    var evt = document.createEvent('MouseEvents');
    evt.initMouseEvent(type, true, true, window, 1, 1, 1, centerX, centerY, false, false, false, false, 0, elem);

    evt.dataTransfer = new DataTransfer();
    elem.dispatchEvent(evt);
  };


  onDragStart = (e) => {
    e.stopPropagation();

    console.log(e.target)

    let dragImage = document.getElementById('dragImage')

    if(dragImage == null){

      dragImage = document.createElement('img')
      dragImage.id = "dragImage"
      dragImage.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=="
      document.body.appendChild(dragImage);
    }

    var testVar = window.DataTransfer || window.Clipboard;  // Clipboard is for Chrome
    if("setDragImage" in testVar.prototype) {
        e.dataTransfer.setDragImage(dragImage, 0, 0)
    }
    if("setData" in testVar.prototype){
        e.dataTransfer.setData('text/plain', '');
    }

    //Set tube visibility to false
    this.props.tubeInWaterBath({
      inWaterBath: false,
      id: this.props.id,
    });

    //Set containsTubeRack in WaterBath to false
    this.props.waterBathContainsTubeRack({
      containsTubeRack: false,
      id: this.props.id,
    });

  }


  render() {
    return (
      <div
      style={{zIndex: "-2", position: 'relative' }}
        aria-label="Water bath."
        className="graphics"
      >
        <TooltipControls
          showControls={this.props.showToolTipControls}
          label={'Water bath'}
          isOpen={this.props.open}
          openShowControlsModal={this.showModal}
          toggleLid={this.toggleOpen}
          onEjectTubeRack={this.ejectRack}
          containsTubeRack={this.props.hasRack}
        />
        {
          !this.props.showToolTipControls ? 
            <div  id="showControlsBtnWaterBath" tabIndex={0} aria-label="Open transilluminator." onClick={this.toggleToolTipControlsForWaterBath} onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleToolTipControlsForWaterBath(e)} }></div>
            : ''
        }
        {/* {this.renderEjectBtn()} */}
        <div id="waterBathOpenBtn" class="" tabIndex={0} aria-label="Open water bath." onClick={this.toggleOpen} onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleOpen(e)} }></div>
        <div id="waterBathModalBtn" tabIndex={0} aria-label="Set water bath settings." onClick={this.showModal} onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.showModal(e)} }></div>
        <img
          style={{ pointerEvents: "none" }}
          src={this.props.open ? images.WaterBathOpen : images.WaterBathClosed}
          aria-label={"Water bath"}
          alt={"Water bath"}
        />
        <div class="floatingRackInsert" style={{display: (this.props.hasRack && this.props.open)? 'initial': 'none', pointerEvents: 'none'}}>
          <FloatingTubeRack id={1}/>
        </div>
        <div
        className="floatingRackDrag"
        draggable
        onDragStart={this.onDragStart}
        //onDragOver={(e)=>{e.persist();this.onDragOver(e);}}
        //onDragEnd={this.onDragEnd}
        style={{display: (this.props.open && this.props.hasRack)?"initial":"none"}}></div>
      </div>
    );
  }
}